import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CGU() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-heading text-xl font-bold uppercase text-slate-900">COACH.</Link>
          <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight uppercase text-slate-900 mb-8">Conditions G&eacute;n&eacute;rales d'Utilisation</h1>

        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 1 &mdash; Objet</h2>
            <p>
              Les pr&eacute;sentes Conditions G&eacute;n&eacute;rales d'Utilisation (CGU) ont pour objet de d&eacute;finir les conditions d'acc&egrave;s
              et d'utilisation de la plateforme Coach, service en ligne de coaching sportif et nutritionnel &eacute;dit&eacute; par Anthony Gillet.
            </p>
            <p className="mt-2">
              L'inscription sur la plateforme implique l'acceptation pleine et enti&egrave;re des pr&eacute;sentes CGU.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 2 &mdash; Description des services</h2>
            <p>La plateforme Coach permet :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Aux <strong>coachs</strong> : cr&eacute;er et g&eacute;rer des programmes d'entra&icirc;nement et de nutrition, suivre la progression de leurs &eacute;l&egrave;ves, communiquer avec eux et g&eacute;rer leurs paiements</li>
              <li>Aux <strong>&eacute;l&egrave;ves</strong> : consulter leurs programmes personnalis&eacute;s, suivre leur progression, &eacute;changer avec leur coach et effectuer leurs paiements</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 3 &mdash; Inscription et comptes</h2>
            <p>
              L'acc&egrave;s aux services n&eacute;cessite la cr&eacute;ation d'un compte. L'utilisateur s'engage &agrave; fournir des informations
              exactes et &agrave; jour lors de son inscription.
            </p>
            <p className="mt-2">
              Chaque utilisateur est responsable de la confidentialit&eacute; de ses identifiants de connexion.
              Toute utilisation du compte est r&eacute;put&eacute;e faite par le titulaire du compte.
            </p>
            <p className="mt-2">
              Trois types de comptes existent sur la plateforme : <strong>Coach</strong>, <strong>&Eacute;l&egrave;ve</strong> et <strong>Administrateur</strong>.
              Chaque r&ocirc;le dispose de fonctionnalit&eacute;s sp&eacute;cifiques.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 4 &mdash; Obligations des utilisateurs</h2>
            <p>L'utilisateur s'engage &agrave; :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Utiliser la plateforme conform&eacute;ment &agrave; sa destination</li>
              <li>Ne pas diffuser de contenu illicite, offensant ou contraire aux bonnes m&oelig;urs</li>
              <li>Ne pas tenter de porter atteinte au fonctionnement de la plateforme</li>
              <li>Respecter les droits de propri&eacute;t&eacute; intellectuelle</li>
              <li>Ne pas revendre ou c&eacute;der l'acc&egrave;s &agrave; son compte</li>
            </ul>
            <p className="mt-3">
              Les coachs s'engagent &eacute;galement &agrave; fournir des programmes adapt&eacute;s et &agrave; ne pas se substituer &agrave; un professionnel de sant&eacute;.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 5 &mdash; Abonnements et paiements</h2>
            <p>
              L'acc&egrave;s &agrave; certaines fonctionnalit&eacute;s de la plateforme est soumis &agrave; la souscription d'un abonnement payant.
              Les tarifs en vigueur sont affich&eacute;s sur la plateforme.
            </p>
            <p className="mt-2">
              Les paiements sont trait&eacute;s de mani&egrave;re s&eacute;curis&eacute;e via Stripe.
              Aucune donn&eacute;e bancaire n'est stock&eacute;e sur nos serveurs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 6 &mdash; Propri&eacute;t&eacute; intellectuelle</h2>
            <p>
              L'ensemble des &eacute;l&eacute;ments de la plateforme Coach (design, code, textes, logos, fonctionnalit&eacute;s) est prot&eacute;g&eacute;
              par le droit de la propri&eacute;t&eacute; intellectuelle et appartient &agrave; Anthony Gillet.
            </p>
            <p className="mt-2">
              Les programmes cr&eacute;&eacute;s par les coachs restent leur propri&eacute;t&eacute; intellectuelle. La plateforme dispose d'un
              droit d'utilisation limit&eacute; aux fins de fourniture du service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 7 &mdash; Limitation de responsabilit&eacute;</h2>
            <p>
              La plateforme Coach est fournie &laquo; en l'&eacute;tat &raquo;. Anthony Gillet ne saurait &ecirc;tre tenu responsable
              des dommages directs ou indirects r&eacute;sultant de l'utilisation de la plateforme.
            </p>
            <p className="mt-2">
              Les programmes de coaching ne constituent pas des avis m&eacute;dicaux. Les utilisateurs sont invit&eacute;s
              &agrave; consulter un m&eacute;decin avant de commencer tout programme sportif ou nutritionnel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 8 &mdash; R&eacute;siliation</h2>
            <p>
              L'utilisateur peut r&eacute;silier son compte &agrave; tout moment via les param&egrave;tres de son profil ou en contactant le support.
            </p>
            <p className="mt-2">
              Anthony Gillet se r&eacute;serve le droit de suspendre ou supprimer un compte en cas de non-respect des pr&eacute;sentes CGU,
              sans pr&eacute;avis ni indemnit&eacute;.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Article 9 &mdash; Droit applicable et litiges</h2>
            <p>
              Les pr&eacute;sentes CGU sont r&eacute;gies par le droit fran&ccedil;ais. En cas de litige relatif &agrave; l'interpr&eacute;tation ou
              l'ex&eacute;cution des pr&eacute;sentes, les parties s'engagent &agrave; rechercher une solution amiable avant toute action judiciaire.
            </p>
            <p className="mt-2">
              &Agrave; d&eacute;faut d'accord amiable, les tribunaux fran&ccedil;ais seront seuls comp&eacute;tents.
            </p>
          </section>

          <section>
            <p className="text-xs text-slate-400">Derni&egrave;re mise &agrave; jour : Mars 2026</p>
          </section>
        </div>
      </main>

      <footer className="border-t border-slate-100 py-6 px-6">
        <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-4 text-xs text-slate-400">
          <Link to="/mentions-legales" className="hover:text-blue-600">Mentions l&eacute;gales</Link>
          <span>&middot;</span>
          <Link to="/politique-confidentialite" className="hover:text-blue-600">Politique de confidentialit&eacute;</Link>
          <span>&middot;</span>
          <Link to="/cgu" className="hover:text-blue-600">CGU</Link>
        </div>
      </footer>
    </div>
  );
}
